export const mobile = {
  0: {
    data: 'Projeniz için size teklif verebilmemiz için ihtiyaçlarınıza göre soruları cevaplayınız',
    datalang: 'offerdescription',
    selectable: false,
    selectOK: 1,
    img: '/project/startup.jpg',
    controls: [],
  },

  1: {
    data: 'İhtiyacınız olan platformları seçiniz',
    datalang: 'needplatform',
    selectable: false,
    selectOK: 3,
    img: '/project/platform.png',

    selectListData: {
      'Android Phone': {
        price: 2500,
        duration: 3,
        image: 'content/images/project/platform/android-phone1.png',
        description: 'Android telefonlar için mobil uygulama',
        datalang: 'needandroid',
      },

      'iOS Phone': {
        price: 3000,
        duration: 3,
        image: 'content/images/project/platform/iphone1.png',
        description: 'iPhone cihazlar için mobil uygulama',
        datalang: 'needios',
      },
      'Android Tablet': {
        price: 1500,
        duration: 2,
        image: 'content/images/project/platform/android-tablet.svg',
        description: 'Android tablet uyumlu uygulama',
        datalang: 'needandroidtab',
      },
      'iOS Tablet': {
        price: 1800,
        duration: 2,
        image: 'content/images/project/platform/ipad.png',
        description: 'iPad uyumlu uygulama',
        datalang: 'neediostab',
      },
      'Android TV': {
        price: 3500,
        duration: 4,
        image: 'content/images/project/platform/apple-tv.png',
        description: 'Android TV uygulaması',
        datalang: 'needandroidtv',
      },
      'Apple TV': {
        price: 3800,
        duration: 4,
        image: 'content/images/project/platform/apple-tv.svg',
        description: 'Apple TV uygulaması',
        datalang: 'neediostv',
      },
      'WebOS TV': {
        price: 3000,
        duration: 4,
        image: 'content/images/project/platform/webos.png',
        description: 'LG WebOS TV uygulaması',
        datalang: 'needwebos',
      },
      Tizen: {
        price: 3000,
        duration: 4,
        image: 'content/images/project/platform/tizen.png',
        description: 'Samsung Tizen TV uygulaması',
        datalang: 'needtizen',
      },
    },
  },

  3: {
    data: 'Uygulamanızda E-posta ile giriş gerekli mi?',
    datalang: 'needlogin',
    selectable: true,
    selectPositive: 4,
    selectNegative: 4,
    selectPositivePrice: 1200,
    selectNegativePrice: 0,
    duration: 1,
    img: '/project/emaillogin.png',
  },

  4: {
    data: 'Google / Apple / Facebook ile sosyal giriş ister misiniz?',
    datalang: 'needsociallogin',
    selectable: true,
    selectPositive: 5,
    selectNegative: 5,
    selectPositivePrice: 1500,
    selectNegativePrice: 0,
    duration: 1,
    img: '/project//sociallogin.png',
  },

  5: {
    data: 'Kullanıcı profil sayfası olacak mı?',
    datalang: 'needprofile',
    selectable: true,
    selectPositive: 6,
    selectNegative: 6,
    selectPositivePrice: 1800,
    selectNegativePrice: 0,
    duration: 2,
    img: '/project/profile.jpg',
  },

  6: {
    data: 'Kullanılacak sensörleri seçiniz',
    datalang: 'needsensors',
    selectable: false,
    selectOK: 8,
    selectListData: {
      Bluetooth: {
        price: 1500,
        duration: 2,
        image: 'content/images/project/sensors/bluetooth.svg',
        description: 'Bluetooth ile cihazlar arası iletişim',
        datalang: 'featurebluetooth',
      },
      Gyroscope: {
        price: 1200,
        duration: 1,
        image: 'content/images/project/sensors/gyroscope.svg',
        description: 'Cihaz yönelim algılama',
        datalang: 'featuregyroscope',
      },
      Accelerometer: {
        price: 1200,
        duration: 1,
        image: 'content/images/project/sensors/accelerometer.svg',
        description: 'Hareket ve ivme ölçümü',
        datalang: 'featureaccelerometer',
      },
      Camera: {
        price: 800,
        duration: 1,
        image: 'content/images/project/sensors/camera.svg',
        description: 'Fotoğraf, QR okuma veya yükleme',
        datalang: 'featurecamera',
      },
    },
    img: '/project/sensors.jpg',
  },

  8: {
    data: 'Uygulama üzerinden ürün veya hizmet satılacak mı?',
    datalang: 'needsell',
    selectable: true,
    selectPositive: 9,
    selectNegative: 9,
    selectPositivePrice: 3000,
    selectNegativePrice: 0,
    duration: 3,
    img: '/project/mobilemoney.jpg',
  },

  9: {
    data: 'Harita ve GPS kullanılacak mı?',
    datalang: 'needgpsmap',
    selectable: true,
    selectPositive: 10,
    selectNegative: 10,
    selectPositivePrice: 2000,
    selectNegativePrice: 0,
    duration: 2,
    img: '/project/maps.jpg',
  },

  10: {
    data: 'Ses veya video yükleme / canlı iletişim olacak mı?',
    datalang: 'needstream',
    selectable: true,
    selectPositive: 11,
    selectNegative: 11,
    selectPositivePrice: 4000,
    selectNegativePrice: 0,
    duration: 4,
    img: '/project/uploadstream.jpg',
  },

  11: {
    data: 'Uygulama ücretli mi olacak?',
    datalang: 'needpaid',
    selectable: true,
    selectPositive: 12,
    selectNegative: 14,
    selectPositivePrice: 1200,
    selectNegativePrice: 0,
    duration: 1,
    img: '/project/mobilemoney.jpg',
  },

  12: {
    data: 'Aylık veya yıllık abonelik olacak mı?',
    datalang: 'needsubsicription',
    selectable: true,
    selectPositive: 14,
    selectNegative: 13,
    selectPositivePrice: 2500,
    selectNegativePrice: 0,
    duration: 2,
    img: '/project/mobilemoney.jpg',
  },

  13: {
    data: 'Uygulama içi satın alma olacak mı?',
    datalang: 'needsellItem',
    selectable: true,
    selectPositive: 14,
    selectNegative: 14,
    selectPositivePrice: 2200,
    selectNegativePrice: 0,
    duration: 2,
    img: '/project/mobilemoney.jpg',
  },

  14: {
    data: 'Web arayüzü / Admin panel gerekli mi?',
    datalang: 'needweb',
    selectable: true,
    selectPositive: 15,
    selectNegative: 15,
    selectPositivePrice: 3500,
    selectNegativePrice: 0,
    duration: 3,
    img: '/project/webui.jpg',
  },

  15: {
    data: 'Teklif ve proje planı tarafınıza iletilecektir',
    datalang: 'needfinish',
    selectable: false,
    selectOK: 15,
    img: '/project/finish.jpg',
  },
};
